import {
  OverridableQuery,
  restrictApi,
  useQuery,
  UseQueryOptions,
  serialize,
} from '@wyz/utils';
import { IErrorApiResponse, ISuccessApiResponse } from '@wyz/types';
import { ConnectQueryKeys } from '~/connect/api';
import { useApi } from '~/common/context';
import { IAlternativeSupplierRankingModel } from '~/connect/types';

type Options = {
  list?: OverridableQuery<
    UseQueryOptions<
      ISuccessApiResponse<IAlternativeSupplierRankingModel[]>,
      IErrorApiResponse
    >
  > & {
    args?: {
      query?: {
        status?: string;
      };
    };
  };
};

export function useManageAlternativeSupplierRankingModel(
  options: Options = {},
) {
  const { callCoreApi } = useApi();
  const listQuery = useQuery({
    queryKey: ConnectQueryKeys.alternativeSupplierRankingModel.base(),
    queryFn: () =>
      callCoreApi<ISuccessApiResponse<IAlternativeSupplierRankingModel[]>>(
        `/settings/api/ranking-models/models?${serialize(
          options.list?.args?.query ?? {},
        )}`,
      ),
    enabled: Boolean(options.list?.enabled),
    ...options.list,
  });

  return restrictApi(options, {
    list: listQuery,
  });
}
